import { useTranslation } from 'next-i18next';
import { twMerge } from 'tailwind-merge';

import { ContactInformationFields } from '@boss/types/corporate-jobs';
import { Button, ContactInfoBlock } from '@boss/ui';

import { getButtonProps, getContactCardProps } from '../../mappers/PropsMapping';
import HeadQuartersMap from '../HeadQuartersMap';

type ContactInformationProps = {
  entry: ContactInformationFields;
  locale: string;
  hasBackground?: boolean;
};

const ContactInformation = ({ entry, hasBackground, locale }: ContactInformationProps) => {
  const { t } = useTranslation(['contact']);
  const textClassName = hasBackground ? 'text-white' : '';

  return (
    <div>
      <h2 className={twMerge('h2 mb-7.5', textClassName)}>{t('details.title')}</h2>
      <ContactInfoBlock {...getContactCardProps(entry, hasBackground)} />
      {entry.ctas?.map(cta => (
        <Button
          key={cta.id}
          {...getButtonProps(cta, locale)}
          className="my-4 w-fit"
          labelClassName={twMerge('font-semibold button', textClassName)}
        />
      ))}
      <HeadQuartersMap />
    </div>
  );
};

export default ContactInformation;
